module.exports = __webpack_public_path__ + "static/img/xiawu01.5efc718c.jpg";